import React, { useEffect, useState, useCallback } from 'react';
import classNames from 'classnames';

const Sider = ({processamentos, handleCurrentProcessamento}) => {
  const [processamentosLista, setProcessamentosLista]   = useState([]);
  const [currentProcessamento, setCurrentProcessamento] = useState(0);

  const mountProcessamentosLista = useCallback((processamentos) => {
    processamentos.forEach((item) => {
      item.html = (
        <li
          key={item.ordem}
          className={classNames('list-group-item small p-1 d-flex justify-content-between align-items-center', {
            'text-muted':        (item.ordem > currentProcessamento.ordem),
            'text-primary':      (item.ordem < currentProcessamento.ordem || currentProcessamento.status === 'finish'),
            'text-white active': (item.ordem === currentProcessamento.ordem && currentProcessamento.status !== 'finish')
          })}
        >
          <div>
            {item.nivel > 2 && Array.from({length: item.nivel - 2}, (_, i) => <span key={i} className='mr-3' />)}
            {item.tipo === 'raiz' ? '.' : '└ '}
            {item.ordem}º {item.numero} ({item.tipo})
          </div>
          <div>
            {(item.ordem < currentProcessamento.ordem || ['finish', 'processando_merge'].includes(currentProcessamento.status)) && (
              <span className='badge badge-primary badge-pill'>
                <i className='fas fa-check' />
              </span>
            )}
            {(currentProcessamento.ordem === item.ordem && currentProcessamento.status !== 'finish') && (
              ['error', 'em_processamento'].includes(currentProcessamento.status) && (
                <span className='badge badge-light badge-pill text-danger'>
                  <i className='fas fa-times' />
                </span>
              ) || (
                <div className='spinner-border spinner-border-sm mr-1 mt-1' role='status'>
                  <span className='sr-only'>Loading...</span>
                </div>
              )

            )}
          </div>
        </li>
      );
    });

    setProcessamentosLista([...processamentos]);
  }, [currentProcessamento]);

  // EFFECT CHANGE CURRENT PROCESSAMENTO
  useEffect(() => {
    if (handleCurrentProcessamento) {
      setCurrentProcessamento(handleCurrentProcessamento);
    }
  }, [handleCurrentProcessamento]);

  // EFFECT MOUNT PROCESSAMENTOS LISTA
  useEffect(() => {
    if (processamentos.length) {
      mountProcessamentosLista(processamentos);
    }
    return () => {};
  }, [processamentos, mountProcessamentosLista]);


  return (
    <>
      <div className='col-4'>
        <ul className='list-group shadow-sm'>{processamentosLista.map((item) => item.html)}</ul>
      </div>
    </>
  );
};

export default React.memo(Sider);
